import {
	InspectionCard,
	InspectionId,
	SurveyDate,
	EventWrapper,
	ViewDetails,
} from './InspectionProperties.styles';
import {
	ItemWithLabel,
	iso8601DateToLocal,
	useSettings,
} from '@innovyze/stylovyze';
import { InspectionScoredAttributes } from '../../utils';
import React from 'react';
import { useGlobalization } from '@Translations/useGlobalization';
import { extractValue } from '../../utils';

export interface EventPropertiesProps {
	inspection: InspectionScoredAttributes;
	viewEvent?: (inspectionAttributes: InspectionScoredAttributes) => void;
}

type TFunc = (text: string) => string | undefined;

const translateStatus = (t: TFunc, status: string): string => {
	switch (status) {
		case 'verified':
			return t('Active') ?? 'Active';
		case 'resolved':
			return t('Resolved') ?? 'Resolved';
		case 'closed':
			return t('Closed') ?? 'Closed';
		default:
			return t('Active') ?? 'Active';
	}
};

export const EventProperties = ({
	inspection,
	viewEvent,
}: EventPropertiesProps): JSX.Element => {
	const { t } = useGlobalization();
	const { companySettings } = useSettings();

	const onEventClick = () => {
		if (viewEvent) viewEvent(inspection);
	};

	return (
		<EventWrapper data-cy="inspection-properties">
			<InspectionId viewDetails={!!viewEvent}>
				{inspection.eventId}
			</InspectionId>
			<SurveyDate viewDetails={!!viewEvent}>
				{iso8601DateToLocal(
					extractValue(inspection.completedDate) ?? '',
					companySettings.dateFormat,
				)}
			</SurveyDate>
			{viewEvent && (
				<ViewDetails size="small" onClick={onEventClick}>
					{t('View Details', {
						context: 'Inspection details view further details',
					})}
				</ViewDetails>
			)}
			<InspectionCard>
				<ItemWithLabel
					label={
						t('Event Type', {
							context: 'Inspection properties',
						}) ?? 'Event Type'
					}
					value={inspection.eventTypeName}
				/>
				<ItemWithLabel
					label={
						t('Opened Date', {
							context: 'Inspection properties',
						}) ?? 'Opened Date'
					}
					value={iso8601DateToLocal(
						inspection.openedDate
							? extractValue(inspection.openedDate) ?? ''
							: '',
						companySettings.dateFormat,
					)}
				/>
				<ItemWithLabel
					label={
						t('Status', {
							context: 'Inspection properties',
						}) ?? 'Status'
					}
					value={translateStatus(t, inspection.inspectionStatus)}
				/>
			</InspectionCard>
		</EventWrapper>
	);
};
